// The one place something is destroyed, so it says what will be destroyed.
//
// Named rather than generic: the employer and the period that will reopen, not
// "Are you sure?". The safe answer is second but full width — this is a thumb
// reaching the bottom of a phone, and both answers should be easy to hit
// correctly.

export interface ConfirmSheetProps {
  title: string
  /** What will actually happen, in the driver's terms. */
  detail?: string
  confirmLabel: string
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmSheet = ({
  title,
  detail,
  confirmLabel,
  cancelLabel = 'Keep it',
  onConfirm,
  onCancel,
}: ConfirmSheetProps) => (
  <div className="px-3.5 pb-3.5 pt-1.5">
    <div className="text-[14px] font-semibold text-doubleNickel-gray-900">
      {title}
    </div>
    {detail && (
      <div className="mt-1.5 text-[11.5px] leading-relaxed text-doubleNickel-gray-600">
        {detail}
      </div>
    )}
    <div className="mt-3 flex flex-col gap-2">
      <button
        type="button"
        onClick={onConfirm}
        className="rounded-lg bg-doubleNickel-error-600 p-3 text-center text-sm font-semibold text-white"
      >
        {confirmLabel}
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="rounded-lg border border-doubleNickel-gray-300 bg-white p-3 text-center text-sm font-semibold text-doubleNickel-gray-700"
      >
        {cancelLabel}
      </button>
    </div>
  </div>
)
